import { useAuthStore } from '@/stores/authStore'
import { SupervisorDashboard } from './SupervisorDashboard'
import { MemberDashboard } from './MemberDashboard'

export function Dashboard() {
  const { user } = useAuthStore()

  if (user?.role === 'supervisor') return <SupervisorDashboard />
  return <MemberDashboard />
}
